import { useState } from 'react';
import { ExpensesList } from './list';
import { ExpenseFormModal } from './ExpenseFormModal';
import { SalaryGeneratorDialog } from './SalaryGeneratorDialog';
import { StaffSalaryConfigModal } from './StaffSalaryConfigModal';
import type { Expense } from '../../types';

export const ExpensesPage = () => {
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState<Expense | null>(null);
  const [salaryDialogOpen, setSalaryDialogOpen] = useState(false);
  const [salaryConfigModalOpen, setSalaryConfigModalOpen] = useState(false);

  const handleCreateClick = () => {
    setSelectedExpense(null);
    setFormModalOpen(true);
  };

  const handleExpenseClick = (expense: Expense) => {
    setSelectedExpense(expense);
    setFormModalOpen(true);
  };

  const handleFormModalClose = () => {
    setFormModalOpen(false);
    setSelectedExpense(null);
  };

  const handleGenerateSalariesClick = () => {
    setSalaryDialogOpen(true);
  };

  const handleSalaryDialogClose = () => {
    setSalaryDialogOpen(false);
  };

  const handleSalaryConfigClick = () => {
    setSalaryConfigModalOpen(true);
  };

  const handleSalaryConfigModalClose = () => {
    setSalaryConfigModalOpen(false);
  };

  return (
    <>
      <ExpensesList
        onCreateClick={handleCreateClick}
        onExpenseClick={handleExpenseClick}
        onGenerateSalariesClick={handleGenerateSalariesClick}
        onSalaryConfigClick={handleSalaryConfigClick}
      />
      <ExpenseFormModal
        open={formModalOpen}
        onClose={handleFormModalClose}
        expense={selectedExpense}
      />
      <SalaryGeneratorDialog open={salaryDialogOpen} onClose={handleSalaryDialogClose} />
      <StaffSalaryConfigModal open={salaryConfigModalOpen} onClose={handleSalaryConfigModalClose} />
    </>
  );
};

export { ExpensesList } from './list';
